


jQuery(document).ready(function() {



  //Burger Menu
  var forEach=function(t,o,r){if("[object Object]"===Object.prototype.toString.call(t))for(var c in t)Object.prototype.hasOwnProperty.call(t,c)&&o.call(r,t[c],c,t);else for(var e=0,l=t.length;l>e;e++)o.call(r,t[e],e,t)};

  var hamburgers = document.querySelectorAll(".hamburger");
  if (hamburgers.length > 0) {
    forEach(hamburgers, function(hamburger) {
      
      hamburger.addEventListener("click", function() {
        this.classList.toggle("is-active");          
        jQuery(".hamburger-label").html() == "Close" ? jQuery(".hamburger-label").html('Menu') : jQuery(".hamburger-label").html('Close');
      }, false);

    });
  }


 jQuery(document).foundation();


  jQuery('.testimonials').slick({
    dots: true,
    arrows: false,
    speed: 1000,
    infinite: true,
    slidesToShow: 3,
    autoplay: true,
    autoplaySpeed: 4000,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
           slidesToShow: 2,
           autoplay: true
        }
      },
      {
        breakpoint: 640,
        settings: {
           slidesToShow: 1,
           autoplay: true
        }
      }

    ]
  });




  //Animations
  /*sal({
      threshold: 0.3,
  });*/



/*
  // Back To Top
  if (jQuery('.back-to-top').length) {
      var scrollTrigger = 1000, // px
          backToTop = function () {
              var scrollTop = jQuery(window).scrollTop();
              if (scrollTop > scrollTrigger) {
                  jQuery('.back-to-top').addClass('shown');
              } else {
                  jQuery('.back-to-top').removeClass('shown');
              }
          };
      backToTop();
      jQuery(window).on('scroll', function () {
          backToTop();
      });
      jQuery('.back-to-top').on('click', function (e) {
          e.preventDefault();
          jQuery('html,body').animate({
              scrollTop: 0
          }, 700);
      });
  }

*/




  // Blog sidebar ment
  jQuery(document).ready(function() {
      jQuery('.blog-list-archive li ul').hide();
      jQuery('.blog-list-archive li a').click(function(){
          jQuery(this).parent().addClass('selected');
          jQuery(this).parent().children('ul').slideDown(250);
          jQuery(this).parent().siblings().children('ul').slideUp(250);
          jQuery(this).parent().siblings().removeClass('selected');
      });
  });
  



});
